import React, { useEffect, useState } from "react"

import {
  Row,
  Col,
  CardBody,
  Card,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"

//redux
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import logo from "../../assets/images/logo-light1.svg"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

import Spinners from "components/Common/Spinner"
import toast from "react-hot-toast"
import eye from "../../assets/images/icons/eye.svg"
import hide from "../../assets/images/icons/hide.svg"
import { useInvestorLoginMutation } from "store/api/investorapi/auth.api"
import { useWealthPartnerLoginMutation } from "store/api/wealthpartnerapi/auth/auth.api"
import { setAccountType } from "store/slices/commonSlice"

const Login = () => {
  //meta title
  document.title = "Login | Prachay"

  const [investorLogin, { isLoading }] = useInvestorLoginMutation()
  const [wealthPartnerLogin, { isLoading: isAuthenticating }] =
    useWealthPartnerLoginMutation()
  const [show, setShow] = useState(false)
  const [loginType, setLoginType] = useState("INVESTOR")

  const dispatch = useDispatch()
  const history = useNavigate()

  //temp redirection
  useEffect(() => {
    // history(`/admin/login`)
  }, [])

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      onLogin(values)
    },
  })

  const onLogin = async (params) => {
    try {
      const { data, message } =
        loginType === "INVESTOR"
          ? await investorLogin(params).unwrap()
          : await wealthPartnerLogin(params).unwrap()
      dispatch(setAccountType(loginType))
      history(`/two-factor/${data.token}`)
      toast.success(message, { id: "toastMessage" })
    } catch (error) {
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <div className="account-pages">
      <Row className="g-0">
        <Col md={7} lg={7} xl={7} className="p-0 m-0">
          <div className="log-in-blue-bg-cover">
            <div className="login-page-text">
              <h4>Managing your</h4>
              <h5>
                <span> CORPORATE TREASURY </span> was never so easy
              </h5>
              <p>Introducing Prachay ICDs</p>
            </div>
            <div className="login-page-bottom-text">
              <h4>DON'T LEAVE</h4>
              <h5>
                YOUR <span style={{ color: "#f0a634" }}>SURPLUS </span>{" "}
                UNMANAGED
              </h5>
            </div>
          </div>
        </Col>

        <Col md={5} lg={5} xl={5}>
          <div className="overflow-hidden login-form-wrapper px-1">
            <Card>
              <CardBody>
                <Link to="/" className="">
                  <img src={logo} alt="" height="50" />
                </Link>
                <div className="login-text mt-3">
                  <h4>Log in to your account</h4>
                  <p>Welcome back! Please enter your details.</p>
                </div>

                <div className="pt-0">
                  <div className="p-2">
                    {/* <div className="login-tab-container">
                      <div
                        className={`tab ${
                          loginType === "INVESTOR" ? "active" : ""
                        }`}
                        onClick={() => setLoginType("INVESTOR")}
                      >
                        Investor
                      </div>
                      <div
                        className={`tab ${
                          loginType === "WEALTH_PARTNER" ? "active" : ""
                        }`}
                        onClick={() => setLoginType("WEALTH_PARTNER")}
                      >
                        Wealth Partner
                      </div>
                    </div> */}
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {/* {error ? <Alert color="danger">{error}</Alert> : null} */}

                      <div className="mb-2">
                        <Label className="form-label">
                          Email Address<span className="error">*</span>
                        </Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter Email Address"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-2">
                        <Label className="form-label">
                          Password <span className="error">*</span>
                        </Label>

                        <div className="input-wrapper">
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={show ? "text" : "password"}
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />

                          <div
                            onClick={() => setShow(!show)}
                            style={{ cursor: "pointer" }}
                          >
                            <img src={show ? hide : eye} alt="" />
                          </div>
                        </div>
                        {validation.touched.password &&
                        validation.errors.password ? (
                          <FormFeedback type="invalid">
                            {validation.errors.password}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <div
                        className="mt-2 text-end"
                        style={{ fontSize: "15px" }}
                      >
                        <Link
                          to="/forgot-password"
                          style={{ color: "#035ca1", fontWeight: "500" }}
                        >
                          Forgot password?
                        </Link>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block position-relative"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading || isAuthenticating ? (
                            <Spinners />
                          ) : (
                            "Log In"
                          )}
                        </button>
                      </div>

                      {loginType === "INVESTOR" && (
                        <div
                          className="mt-4 text-center"
                          style={{ fontSize: "15px" }}
                        >
                          Do not have account?{" "}
                          <Link
                            to="/register"
                            style={{ color: "#035ca1", fontWeight: "bold" }}
                          >
                            Register
                          </Link>
                        </div>
                      )}
                    </Form>
                  </div>
                </div>
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default withRouter(Login)

// Login.propTypes = {
//   history: PropTypes.object,
// };
